import script from "./EmploymentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmploymentView.vue?vue&type=script&lang=ts&setup=true"

import "./EmploymentView.vue?vue&type=style&index=0&id=632c1710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632c1710"]])

export default __exports__